(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:AssignTeams
   *
   * @description
   *
   */
  angular
      .module('neo.services')
      .factory('AssignTeams', AssignTeams);

  function AssignTeams($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/championships/:championshipId/teams', {championshipId: '@_championshipId'}, {
      update: {
        method: 'PUT'
      }
    });
  }
}());
